import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"zap, lightning, flash, thunder"} maskId="square-filled-radius-0-stroke-1-IconZap"><path d="M14.0014 0.212402L2.51953 16H10.0014V23.7876L21.4833 7.99999H14.0014V0.212402Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconZap;
